import { Plugin } from 'ckeditor5';

declare module '@ckeditor/ckeditor5-core' {
  interface EditorConfig {
    width?: string;
    height?: string;
  }
}

class SizePlugin extends Plugin {
  afterInit() {
    const height = this.editor.config.get('height') as string | undefined;

    this.editor.ui.view.extendTemplate({
      attributes: {
        style: {
          width: this.editor.config.get('width') as string | undefined,
          minHeight: height ? `calc(${height} + 39px)` : undefined,
        },
      },
    });

    if (height) {
      this.editor.ui.view.editable.extendTemplate({
        attributes: {
          style: {
            minHeight: height,
          },
        },
      });

      this.listenTo(this.editor.plugins.get('SourceEditing'), 'change:isSourceEditingMode', () => {
        // Cast to access private variable
        const roots =
          /* eslint-disable @typescript-eslint/naming-convention */
          (
            this.editor.plugins.get('SourceEditing') as unknown as { _replacedRoots: Map<string, HTMLElement> }
          )._replacedRoots.values();
        /* eslint-enable @typescript-eslint/naming-convention */

        for (const root of roots) {
          root.style.minHeight = `calc(${height} + 2px)`;
        }
      });
    }
  }
}

export default SizePlugin;
